import React, { useEffect, useState } from "react";
import Select from "react-select";

const BASE_MIN_WIDTH = 150;
const INDICATOR_WIDTH = 56;
const HORIZONTAL_PADDING = 40;
const DEFAULT_FONT = "14px -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif";

const getLabelText = (option: any) => {
  if (option == null) {
    return "";
  }
  if (typeof option === "string") {
    return option;
  }
  return option.label ?? "";
};

const measureSelectWidth = (options: any[], value: any, placeholder?: string) => {
  if (typeof document === "undefined") {
    return BASE_MIN_WIDTH;
  }

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) {
    return BASE_MIN_WIDTH;
  }

  context.font = DEFAULT_FONT;

  const candidates = [
    ...options.map((option) => getLabelText(option)),
    getLabelText(value),
    placeholder ?? "",
  ];

  const maxLabelWidth = candidates.reduce((maxWidth, label) => {
    const nextWidth = context.measureText(label).width;
    return Math.max(maxWidth, nextWidth);
  }, 0);

  return Math.max(BASE_MIN_WIDTH, Math.ceil(maxLabelWidth + INDICATOR_WIDTH + HORIZONTAL_PADDING));
};

function CustomSelect(props: any) {
  const {
    value,
    options = [],
    className,
    onChange,
    placeholder,
    autoWidth = true,
    styles,
    ...rest
  } = props;
  const [selectWidth, setSelectWidth] = useState(BASE_MIN_WIDTH);

  useEffect(() => {
    if (!autoWidth) {
      return;
    }
    setSelectWidth(measureSelectWidth(options, value, placeholder));
  }, [autoWidth, options, placeholder, value]);

  return (
    <Select
      value={value}
      options={options}
      className={className}
      onChange={(e: any) => onChange(e)}
      placeholder={placeholder}
      isSearchable={options.length > 9}
      styles={{
        container: (base: any) => ({
          ...base,
          width: autoWidth ? selectWidth : base.width,
          minWidth: autoWidth ? selectWidth : base.minWidth,
        }),
        singleValue: (base: any) => ({
          ...base,
          maxWidth: "100%",
        }),
        ...styles,
      }}
      {...rest}
    />
  );
};

export default CustomSelect;
